import { render, staticRenderFns } from "./pointsManagement.vue?vue&type=template&id=3ea2c060&scoped=true&"
import script from "./pointsManagement.vue?vue&type=script&lang=js&"
export * from "./pointsManagement.vue?vue&type=script&lang=js&"
import style0 from "./pointsManagement.vue?vue&type=style&index=0&id=3ea2c060&lang=less&scoped=true&"
import style1 from "./pointsManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea2c060",
  null
  
)

export default component.exports